import Client from '@/clients/apiClient';
import ClientFile from '@/clients/fileClient';
import humps from 'humps';
import { stringify } from 'query-string';

const resource = 'users';

export default {
  get(payload) {
    return Client.get(
      `/${resource}?page=${payload.page}&limit=${payload.perPage}&sort[field]=${humps.decamelize(
        payload.sort.field
      )}&sort[type]=${payload.sort.type}&${stringify(humps.decamelizeKeys(payload.filters))}`
    );
  },
  getSelf(id) {
    return Client.get(`/${resource}/${id}`);
  },
  create(payload) {
    return Client.post(`/${resource}`, payload);
  },
  update(id, payload) {
    return Client.put(`/${resource}/${id}`, payload);
  },
  delete(id) {
    return Client.delete(`/${resource}/${id}`);
  },
  import(payload) {
    return ClientFile.post(`/${resource}/import`, payload);
  },
  download(payload) {
    return Client.get(
      `/${resource}/download?start_date=${payload.startDate}&end_date=${payload.endDate}`
    );
  },
  export(payload) {
    return Client.get(
      `/${resource}/export?sort[field]=${humps.decamelize(payload.sort.field)}&sort[type]=${
        payload.sort.type
      }&${stringify(humps.decamelizeKeys(payload.filters))}`
    );
  },
  changeStatus(id, action) {
    return Client.post(`/${resource}/${id}/${action}`);
  },
  downloadDocument(id, payload) {
    return Client.post(`/${resource}/${id}/document`, payload);
  },
  uploadImage(id, payload) {
    const formData = new FormData();
    formData.append('file', payload.file);
    formData.append('type', payload.type);
    return ClientFile.post(`/${resource}/${id}/image-upload`, formData);
  },
  increaseLimit(id, payload) {
    return Client.post(`/${resource}/${id}/add-limit`, payload);
  },
  downloadCreditDatabase(id) {
    return Client.post(`/${resource}/${id}/download-credit-database`);
  },
  updateContractDate(id, payload) {
    return Client.post(`/${resource}/${id}/contract-date`, payload);
  },
  createLoan(id, payload) {
    return Client.post(`/${resource}/${id}/create-loan`, payload);
  },
};
